module.exports = __webpack_public_path__ + "assets/images/container_phase5.0c1aa52b917ea53bb7fbd0034f8c8294.svg";